import { motion } from 'framer-motion'

export default function Terms() {
  return (
    <div className="min-h-screen bg-pp-ivory">
      {/* Hero */}
      <section className="bg-pp-linen py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="font-display text-display-lg text-pp-ink mb-6">
              Terms of Service
            </h1>
            <p className="text-pp-stone text-lg leading-relaxed">
              Last updated: January 2024
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl mx-auto"
          >
            <div className="bg-white rounded-2xl p-8 lg:p-12 border border-pp-sand/50 space-y-8 text-pp-stone">
              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Agreement to Terms
                </h2>
                <p className="leading-relaxed">
                  By accessing or using the Petite Palate website
                  (petitepalate.com.au) and purchasing our products, you agree to be
                  bound by these Terms of Service. If you do not agree to these
                  terms, please do not use our website or services.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Products and Pricing
                </h2>
                <div className="space-y-4 text-sm leading-relaxed">
                  <p>
                    All prices are displayed in Australian Dollars (AUD) and include
                    GST. We reserve the right to modify prices at any time without
                    prior notice, though any changes will not affect orders already
                    placed.
                  </p>
                  <p>
                    We make every effort to display product colours and details
                    accurately, but we cannot guarantee that your device's display
                    will accurately reflect actual product colours.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Orders and Payment
                </h2>
                <div className="space-y-4 text-sm leading-relaxed">
                  <p>
                    By placing an order, you warrant that you are legally capable of
                    entering into binding contracts and that all information you
                    provide is accurate and complete.
                  </p>
                  <p>
                    We reserve the right to refuse or cancel any order for any
                    reason, including suspected fraud, product unavailability, or
                    pricing errors. If we cancel your order after payment, we will
                    provide a full refund.
                  </p>
                  <p>
                    Payment is processed securely through Stripe. We do not store
                    your complete payment information on our servers.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Shipping and Delivery
                </h2>
                <p className="leading-relaxed text-sm">
                  Shipping times are estimates and not guaranteed. We are not
                  responsible for delays caused by shipping carriers, customs, or
                  other circumstances beyond our control. Risk of loss and title for
                  items pass to you upon delivery to the carrier.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Returns and Refunds
                </h2>
                <p className="leading-relaxed text-sm">
                  Please refer to our Shipping & Returns page for detailed
                  information about our return policy. By making a purchase, you
                  agree to the terms outlined in that policy.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Product Safety
                </h2>
                <div className="space-y-4 text-sm leading-relaxed">
                  <p>
                    Our products are designed for use by infants and young children
                    under adult supervision. Please follow all care and safety
                    instructions provided with each product.
                  </p>
                  <p>
                    While our products meet Australian safety standards, you agree
                    to supervise children during use and regularly inspect products
                    for signs of wear or damage.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Intellectual Property
                </h2>
                <p className="leading-relaxed text-sm">
                  All content on this website, including text, images, logos,
                  product designs, and graphics, is the property of Petite Palate
                  and is protected by Australian and international copyright laws.
                  You may not reproduce, distribute, or use any content without our
                  prior written permission.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Limitation of Liability
                </h2>
                <p className="leading-relaxed text-sm">
                  To the fullest extent permitted by Australian law, Petite Palate
                  shall not be liable for any indirect, incidental, special,
                  consequential, or punitive damages arising from your use of our
                  website or products. Our liability is limited to the purchase
                  price of the products in question.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Governing Law
                </h2>
                <p className="leading-relaxed text-sm">
                  These Terms of Service are governed by the laws of Victoria,
                  Australia. Any disputes arising from these terms or your use of
                  our website shall be resolved in the courts of Victoria.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Changes to Terms
                </h2>
                <p className="leading-relaxed text-sm">
                  We reserve the right to modify these Terms of Service at any time.
                  Changes will be effective immediately upon posting to the website.
                  Your continued use of the website after any changes constitutes
                  acceptance of the new terms.
                </p>
              </section>

              <section>
                <h2 className="font-display text-xl text-pp-ink mb-4">
                  Contact Information
                </h2>
                <p className="leading-relaxed text-sm">
                  For questions about these Terms of Service, please contact us at:
                </p>
                <p className="mt-4 text-sm">
                  Email: hello@petitepalate.com.au
                  <br />
                  Petite Palate
                  <br />
                  Melbourne, Australia
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}
